import { AppKey } from '../app/AppKey';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { updateKeyValue } from '../store/app/action-creators';
import { setCookiesAccepted } from '../store/auth/action-creators';
import { GdprEventSetup } from './GdprEvent';
const LOG = Logger.getLogger('setupGdpr');

const onGdprEvent = (event, store) => {
  if (event.detail && event.detail.country) {
    store.dispatch(updateKeyValue(AppKey.Country, event.detail.country));
  }

  if (event.detail && event.detail.consent && event.detail.consent.allowed) {
    store.dispatch(setCookiesAccepted());
  }
};

export const setupGdpr = store => {
  GdprEventSetup().catch(error => {
    LOG.warn('Error with GDPR Setup', {
      extra: getSentryExtra(error)
    });
  });
  document.addEventListener('gdpr', event => {
    onGdprEvent(event, store);
  });
};